<template>
	<div>
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputWhat" placeholder="请输入姓名" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<!--<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">推广量:</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="Amount1" placeholder="请输入" size="mini" style="width: 100px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">~</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="Amount2" placeholder="请输入" size="mini" style="width: 100px;"></el-input>
				</el-form-item>-->
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="mini" @click="Find">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" size="mini" @click="refersh" >刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight">
		    <el-table-column label="姓名" prop="name" width="120">
		    	<template slot-scope="scope">
		    		<el-button type="text" size="small" @click="lookDetailfirst(scope.$index,scope.row)">{{scope.row.name}}</el-button>
		    	</template>
		    </el-table-column>
		    <el-table-column label="推广人数" prop="recommended_quantity.total" width="100"></el-table-column>
		    <el-table-column label="推广列表">
		    	<template slot-scope="scope">
		    		<el-button v-for='item in scope.row.recommended_quantity.list' :key='item._id' type="primary" plain size="small" :data-id='item._id' @click="lookDetail(item._id)">{{item.name}}</el-button>
				</template>
		    </el-table-column>
		    <el-table-column label="上级人员" width="100">
		    	<template slot-scope="scope">
		    		<span v-if="scope.row.referee">
		    			<el-button type="text" size="small" @click="lookDetaillast(scope.$index,scope.row)">{{scope.row.referee.name}}</el-button>
		    		</span>
		    	</template>
		    </el-table-column>
		</el-table>
		
		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-sizes="[50]" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		<el-dialog title="信息详情" :visible.sync="DetailVisible" center top="5%">
			<div :model='userData' id="messageBox">
				<el-row :span="24">
					<el-col :span="8">姓名：<span>{{userData.name}}</span></el-col>
					<el-col :span="8">性别：<span>{{gender(userData.gender)}}</span></el-col>
					<el-col :span="8">身份证：<span>{{userData.ID_card_number}}</span></el-col>
					
				</el-row>
				<el-row :span="24">
					<el-col :span="8">电话：<span>{{userData.phone}}</span></el-col>
					<el-col :span="8">出生年月：<span>{{birthtime(userData.birth)}}</span></el-col>
					<el-col :span="8">受伤时间：<span>{{birthtime(userData.injurytime)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="8">身高：<span>{{userData.height}} (cm)</span></el-col>
					<el-col :span="8">体重：<span>{{userData.weight}} (kg)</span></el-col>
					<el-col :span="8">腰围：<span>{{userData.waist}} (cm)</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="8">学历：<span>{{userData.edu}}</span></el-col>
					<el-col :span="8">职业：<span>{{job(userData.job)}}</span></el-col>
					<el-col :span="8">录入时间：<span>{{creattime(userData.created_at)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="12">常住地：<span>{{addr(userData.addr)}}</span></el-col>
				</el-row>
				<el-row :span="24">脊柱损伤：</el-row>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="22">颈椎段：<span>{{AQ11(userData.AQ1)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="22">胸椎段：<span>{{AQ12(userData.AQ1)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="22">腰椎段：<span>{{AQ13(userData.AQ1)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="22">骶椎段：<span>{{AQ14(userData.AQ1)}}</span></el-col>
				</el-row>
				<p>其他病种：<span>{{othersick(userData.AQ2)}}</span></p>
				<p>适用判断：</p>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="11">近期是否站立训练：<span>{{stand(userData.AQ3)}}</span></el-col>
					<el-col :span="11">骨密度：<span>{{stone(userData.AQ3)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="11">痉挛登记：<span>{{spasm(userData.AQ3)}}</span></el-col>
					<el-col :span="11">上肢及手功能登记：<span>{{motion(userData.AQ3)}}</span></el-col>
				</el-row>
				<p>禁忌情况：</p>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="11">体位性低血压：<span>{{no1(userData.AQ4)}}</span></el-col>
					<el-col :span="11">脊柱侧弯：<span>{{no2(userData.AQ4)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="11">关节严重变形：<span>{{no3(userData.AQ4)}}</span></el-col>
					<el-col :span="11">长短腿：<span>{{no4(userData.AQ4)}}</span></el-col>
				</el-row>
				<el-row :span="24">
					<el-col :span="2"></el-col>
					<el-col :span="11">认知障碍：<span>{{no5(userData.AQ4)}}</span></el-col>
					<el-col :span="11"></el-col>
				</el-row>
			</div>
			
		</el-dialog>
		
	</div>
</template>

<script>
	import moment from 'moment'
	import {GetUsersDetail} from '../api/api';
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:600,
				Limits:"",
				inputMore:"",
				selectMore:"",
				List:[],
				listloading:false,
				Pagesize:50,
				Curpage:1,
				total:1,
				DetailVisible:false,
				userData:{},
				inputWhat:"",
				searchData:""
			}
		},
		methods:{
//			地址
			addr(param){
				if(param){
					return param[0] + param[1]
				}
			},
//			录入时间
			creattime(param){
				if(param){
					var date = param * 1000
					return moment(date).format("YYYY-MM-DD") 
				}
			},
			birthtime(param){
				if(param){
					var date = param * 1000
					return moment(date).format("YYYY-MM") 
				}
			},
//			性别
			gender(param){
				if(param){
					if(param == 1){return '男'}
					else if(param == 2){return '女'}
				}
			},
//			职业
			job(param){
				if(param){
					if(param == 1){return '无'}
					else if(param == 2){return '学生'}
					else if(param == 3){return '文化/艺术'}
					else if(param == 4){return '影视/娱乐'}
					else if(param == 5){return '金融'}
					else if(param == 6){return '医药/健康'}
					else if(param == 7){return '工业/制造业'}
					else if(param == 8){return '建筑'}
					else if(param == 9){return '司机'}
					else if(param == 10){return '公职'}
					else if(param == 11){return 'IT/互联网/通信'}
					else if(param == 12){return '媒体/公关'}
					else if(param == 13){return '零售'}
					else if(param == 14){return '教育/科研'}
				}
			},
//			脊柱损伤
			AQ11(param){
				if(param){
					var str = ''
					for(var i in param){
						if(param[i] == 17){str += 'C2~C3,'}
						if(param[i] == 18){str += 'C3~C4,'}
						if(param[i] == 19){str += 'C4~C5,'}
						if(param[i] == 20){str += 'C5~C6,'}
						if(param[i] == 21){str += 'C6~C7,'}
						if(param[i] == 22){str += 'C7~C8'}
					}
					return str
				}
			},
			AQ12(param){
				if(param){
					var str = ''
					for(var i in param){
						if(param[i] == 33){str += 'T1~T2,'}
						if(param[i] == 34){str += 'T2~T3,'}
						if(param[i] == 35){str += 'T3~T4,'}
						if(param[i] == 36){str += 'T4~T5,'}
						if(param[i] == 37){str += 'T5~T6,'}
						if(param[i] == 38){str += 'T6~T7,'}
						if(param[i] == 39){str += 'T7~T8,'}
						if(param[i] == 40){str += 'T8~T9,'}
						if(param[i] == 41){str += 'T9~T10,'}
						if(param[i] == 42){str += 'T10~T11,'}
						if(param[i] == 43){str += 'T11~T12'}
					}
					return str
				}
			},
			AQ13(param){
				if(param){
					var str = ''
					for(var i in param){
						if(param[i] == 49){str += 'L1~L2,'}
						if(param[i] == 50){str += 'L2~L3,'}
						if(param[i] == 51){str += 'L3~L4,'}
						if(param[i] == 52){str += 'L4~L5'}
					}
					return str
				}
			},
			AQ14(param){
				if(param){
					var str = ''
					for(var i in param){
						if(param[i] == 65){str += 'S1~S2,'}
						if(param[i] == 66){str += 'S2~S3,'}
						if(param[i] == 67){str += 'S3~S4,'}
						if(param[i] == 68){str += 'S4~S5,'}
					}
					return str
				}
			},
//			其他病种
			othersick(param){
				var str = ''
				if(param){
					if(param.length > 0){
						for(var i in param){
							if(param[i] == 1){str += '脑卒中,'}
							if(param[i] == 2){str += '脑瘫,'}
							if(param[i] == 3){str += '原发性脊髓炎,'}
							if(param[i] == 4){str += '小儿麻痹,'}
							if(param[i] == 5){str += '创伤性脑损伤,'}
							if(param[i] == 6){str += '骨关节炎,'}
							if(param[i] == 7){str += '进行性肌营养不良,'}
							if(param[i] == 8){str += '帕金森综合症,'}
							if(param[i] == 9){str += '阿尔茨海默病(老年痴呆),'}
							if(typeof param[i] == 'string'){str += param[i] + '，'}
						}
						return str
					}else{
						return '无'
					}
					
				}
			},
//			站立格式
			stand(param){
				if(param){
					if(param[0] == 17){return '无'}
					else if(param[0] == 18){return '每天'}
					else if(param[0] == 19){return '偶尔'}
					else {return '未知'}
				}
			},
//			骨密度
			stone(param){
				if(param){
					if(param[1] == 34){return 'T≤1'}
					else if(param[1] == 35){return '1≤T≤2.5'}
					else if(param[1] == 36){return 'T>2.5'}
					else {return '未知'}
				}
			},
//			痉挛等级
			spasm(param){
				if(param){
					if(param[2] == 50){return '0级'}
					else if(param[2] == 51){return '1级'}
					else if(param[2] == 52){return '2级'}
					else if(param[2] == 53){return '3级'}
					else if(param[2] == 54){return '4级'}
					else if(param[2] == 55){return '5级'}
					else {return '未知'}
				}
			},
//			上肢及手功能等级
			motion(param){
				if(param){
					if(param[3] == 66){return '1级'}
					else if(param[3] == 67){return '2级'}
					else if(param[3] == 68){return '3级'}
					else if(param[3] == 69){return '4级'}
					else if(param[3] == 70){return '5级'}
					else if(param[3] == 71){return '6级'}
					else {return '未知'}
				}
			},
//			禁忌情况
			no1(param){
				if(param){
					if(param[0] == 16){return '否'}
					else if(param[0] == 17){return '是'}
					else {return '未知'}
				}
			},
			no2(param){
				if(param){
					if(param[1] == 32){return '否'}
					else if(param[1] == 33){return '是'}
					else {return '未知'}
				}
			},
			no3(param){
				if(param){
					if(param[2] == 48){return '否'}
					else if(param[2] == 49){return '是'}
					else {return '未知'}
				}
			},
			no4(param){
				if(param){
					if(param[3] == 64){return '否'}
					else if(param[3] == 65){return '是'}
					else {return '未知'}
				}
			},
			no5(param){
				if(param){
					if(param[4] == 80){return '否'}
					else if(param[4] == 81){return '是'}
					else {return '未知'}
				}
			},
			lookDetail(e){
				this.GetDetail(e)
			},
			lookDetailfirst(index,row){
				var form = Object.assign({}, row);
				this.GetDetail(form._id)
			},
			lookDetaillast(index,row){
				var form = Object.assign({}, row);
				this.GetDetail(form.referee._id)
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.GetList()
			},
//			刷新
			refersh(){
				var that = this
				that.inputWhat = ''
				that.Curpage = 1
				that.GetList()
			},
//			搜索
			Find(){
				var that = this
				if(that.inputWhat){
					var search = ''
					if(that.inputWhat){search = [{"AND":{"name":"~" + that.inputWhat}}]}
					that.searchData = JSON.stringify(search)
					let param = {
						token:that.token,
						fields:'_id,name,recommended_quantity,referee',
						perPage:that.Pagesize,
						page:that.Curpage,
						q:that.searchData
					}
					that.GetListlow(param)
				}
			},
			GetDetail(userid){
				var that = this
				let url = '/questionnaires/' + userid + '?token=' + that.token
				that.axios(url).then(res => {
					console.log(res)
					that.DetailVisible = true
					that.userData = res.data
				}).catch(err => {
					console.log(err)
				})
			},
			GetListlow(param){
				var that = this
				GetUsersDetail(param).then(res => {
					console.log(res)
					that.List = res.data.items
					that.total = res.data.meta.totalCount
				}).catch(err => {
					console.log(err)
				})
			},
			GetList(){
				var that = this
				let param = {
					token:that.token,
					fields:'_id,name,recommended_quantity,referee',
					perPage:that.Pagesize,
					page:that.Curpage
				}
				that.GetListlow(param)
			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetList()
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>
.el-select{
		width: 90px;
	}
	
#messageBox {
	font-size: 16px;
	color: #999;
}
#messageBox .el-col {
	margin-bottom: 15px;
}
#messageBox span {
	color: #3c3c3c;
	font-size: 18px;
}

</style>


// WEBPACK FOOTER //
// CustomerPopular.vue?b556c632